import { useState } from "react";

export default function BotonCompartir({
  id,
  descripcion,
  link: linkProp,
  text = "",
  className = "",
}) {
  const [mostrarModal, setMostrarModal] = useState(false);

  const link =
    linkProp ||
    `${window.location.origin}${window.location.pathname}#obj-${id}`;

  const handleCompartir = async () => {
    if (navigator.share) {
      // 📱 Compartir nativo en mobile
      try {
        await navigator.share({
          title: "Objeto perdido en el Club",
          text: descripcion,
          url: link,
        });
      } catch (err) {
        console.log("Compartir cancelado", err);
      }
    } else {
      // 💻 Fallback en desktop → abrir modal
      setMostrarModal(true);
    }
  };

  const handleCopiar = async () => {
    await navigator.clipboard.writeText(link);
    alert("📋 Link copiado!");
    setMostrarModal(false);
  };

  return (
    <>
      <button
        onClick={handleCompartir}
        className={`share absolute top-2 right-3 flex items-center gap-2 px-2 py-1 bg-white rounded hover:bg-gray-50 border border-input transition justify-center ${className}`}
        title="Compartir objeto"
      >
        {/* Ícono */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-share"
        >
          <path d="M12 2v13" />
          <path d="m16 6-4-4-4 4" />
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
        </svg>
        {text && <span className="">{text}</span>}
      </button>

      {/* Modal Fallback */}
      {mostrarModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
          <div className="bg-white rounded-xl p-6 shadow-xl w-72 space-y-4 relative">
            <button
              onClick={() => setMostrarModal(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-black"
            >
              ✕
            </button>

            <h2 className="text-lg font-semibold text-center">
              Compartir objeto
            </h2>

            <div className="flex flex-col gap-3">
              {/* WhatsApp */}
              <a
                href={`https://wa.me/?text=${encodeURIComponent(
                  descripcion + " " + link
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-3 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition"
              >
                💬 WhatsApp
              </a>

              {/* Facebook */}
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  link
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-3 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
              >
                👍 Facebook
              </a>

              {/* Copiar link */}
              <button
                onClick={handleCopiar}
                className="flex items-center gap-2 px-3 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition"
              >
                📋 Copiar link
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
